import Thing from '../types/Thing';
import Things from '../types/Things';
import { nvFetch } from './nvFetch';

const NUM_RETRIES = 1;
const RETRY_DELAY = 500;

export const sleep = (time: number) =>
  new Promise<void>((res) => {
    setTimeout(() => {
      res();
    }, time);
  });

export const completelyFetchResource = async <T extends Thing>(
  resourceUrl: string,
  queryString: string,
  params: {
    pageSize: number;
  },
  activeCustomerId: string,
  onPageFetched?: (items: T[]) => void,
) => {
  let page = 1;
  let lastError: Error | undefined = undefined;
  const allData: T[] = [];

  while (true) {
    let data: Things<T> | undefined = undefined;
    let retriesLeft = NUM_RETRIES;
    while (retriesLeft >= 0) {
      try {
        data = (await (
          await nvFetch(
            `customers/${activeCustomerId}/${resourceUrl}?page=${page}&pageSize=${params.pageSize}${queryString}`,
          )
        ).json()) as Things<T>;
        // dispatch(
        //   new SuccessAction(actionsTypes.receive, {
        //     items: data.items,
        //   }).json,
        // );
        onPageFetched?.(data.items);
        allData.push(...data.items);
        break;
      } catch (error) {
        retriesLeft -= 1;
        lastError = error as Error;
        if (retriesLeft >= 0) {
          await sleep(RETRY_DELAY);
        }
      }
    }

    if (retriesLeft < 0 && lastError) {
      throw lastError;
    }

    if (data?.nextPage) {
      page += 1;
    } else {
      break;
    }
  }
  return allData;
};
